export default function QuestionCell({
  theme,
  onClick,
  key,
  answered,
  focusQuestion,
}) {
  return (
    <button
      class="question-cell"
      onClick={onClick}
      style={{
        "background-color": focusQuestion() == key ? "#3b3b3b" : "#242424",
        color: answered() ? "#7a7a7a" : "#f2f0ef",
        "border-color": answered() ? "#7a7a7a" : "#f2f0ef",
      }}>
      {theme}
    </button>
  );
}
